import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  getUrl(url: string): string {
    return environment.apiUrl + url
  }

  get getSmartyUrl(): string {
    return environment.smartyApiUrl
  }

  get getSmartyKey(): string {
    return environment.smartyApiKey
  }

  getSignalrUrl(url: string): string {
    return environment.signalRurl + url
  }

  getIgnoreEncryption(): boolean {
    return environment.ignoreEncryption
  }


  get sessionDecryptKey() {
    return environment.sessionDecryptKey
  }

  get env() {
    return { ...environment }
  }
}
